import React from 'react';
import { useNavigate } from 'react-router-dom';
import { clearAuth, getUser } from '../utils/auth';
import DashboardLayout from '../components/DashboardLayout';
import DashboardActionCard, { SearchIcon, BookmarkIcon } from '../components/DashboardActionCard';

const TeamLeadHome = () => {
  const navigate = useNavigate();
  const user = getUser();

  const handleLogout = () => {
    clearAuth();
    navigate('/');
  };

  return (
    <DashboardLayout
      eyebrow="TEAM LEAD DASHBOARD"
      heading="Welcome back"
      subtitle="Search live postings across job boards, or pick up where your team left off on saved roles."
      email={user?.email}
      onLogout={handleLogout}
    >
      <DashboardActionCard
        to="/team-lead/jobs-search"
        icon={<SearchIcon />}
        iconBg="rgba(201, 151, 58, 0.12)"
        title="Search Jobs"
        description="Pull fresh postings from LinkedIn, Indeed and other boards by title, location or industry."
      />
      <DashboardActionCard
        to="/team-lead/saved-jobs"
        icon={<BookmarkIcon />}
        iconBg="rgba(22, 50, 79, 0.08)"
        title="View Saved Jobs"
        description="Browse, filter and revisit every job your team has already saved to the database."
      />
    </DashboardLayout>
  );
};

export default TeamLeadHome;
